import {API} from "aws-amplify";
import {GRAPHQL_AUTH_MODE, GraphQLQuery} from "@aws-amplify/api";
import {SubmitImageFeedbackMutation, SubmitImageFeedbackMutationVariables} from "../../API";
import * as mutations from "../../graphql/mutations";

export const submitImageFeedback = async (
    id: any,
    bucket: string,
    key: string,
    isUseful: boolean
): Promise<any> => {
    try {
        const result = await API.graphql<GraphQLQuery<SubmitImageFeedbackMutation>>(
            {
                query: mutations.submitImageFeedback,
                variables: {
                    id: id,
                    bucket: bucket,
                    key: key,
                    isUseful: isUseful,
                } as SubmitImageFeedbackMutationVariables,
                authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            }
        );
        if (result.data) {
            const data = result.data.submitImageFeedback;
            if (data) {
                const parsedData = JSON.parse(data);
                return parsedData["statusCode"] === 200;

            }
        }
    } catch (error) {
        console.error(error);
        return false;
    }
};
